import { a as addPrevNextBtnsClickHandlersSSR, f as addDotsBtnsAndClickHandlersSSR, h as addInstagramDotBtnsAndClickHandlers } from "./embla-extension-BBVpnNKd.js";
import "./native-scroll-snap-Cd15iSfl.js";
import "./utilities-ClmlCyst.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import "./mobile-anim-gate-Btn1wVuD.js";
import "./mobile-autoplay-LQAitT2O.js";
import "./progressive-images-mIwHxxsh.js";
import "./autoplay-progress-BLL6tdZq.js";
const designModeInitJobs = /* @__PURE__ */ new WeakMap();
const designModeInitQueue = [];
let designModeInitScheduled = false;
function requestDesignModeInitTurn(callback) {
  setTimeout(callback, 0);
}
function scheduleNextDesignModeInit() {
  if (designModeInitScheduled || designModeInitQueue.length === 0) return;
  designModeInitScheduled = true;
  requestDesignModeInitTurn(runNextDesignModeInit);
}
function runNextDesignModeInit() {
  var _a, _b;
  designModeInitScheduled = false;
  let job = null;
  while (designModeInitQueue.length > 0 && !job) {
    const candidate = designModeInitQueue.shift();
    if (!candidate.cancelled) job = candidate;
  }
  if (!job) return;
  if (designModeInitJobs.get(job.host) === job) {
    designModeInitJobs.delete(job.host);
  }
  try {
    if (job.host.isConnected && !((_b = (_a = job.host).isInteractionReady) == null ? void 0 : _b.call(_a)) && typeof job.host.init === "function") {
      job.host.init();
    }
  } finally {
    setTimeout(scheduleNextDesignModeInit, 0);
  }
}
function cancelDesignModeListingInit(host) {
  const job = designModeInitJobs.get(host);
  if (!job) return;
  job.cancelled = true;
  designModeInitJobs.delete(host);
}
function scheduleDesignModeListingInit(host) {
  var _a, _b;
  if (!((_a = window.Shopify) == null ? void 0 : _a.designMode) || !(host == null ? void 0 : host.isConnected)) return false;
  if ((_b = host.isInteractionReady) == null ? void 0 : _b.call(host)) return true;
  cancelDesignModeListingInit(host);
  const job = { host, cancelled: false };
  designModeInitJobs.set(host, job);
  designModeInitQueue.push(job);
  scheduleNextDesignModeInit();
  return true;
}
function parseLiquidJSON(jsonString, fallback, componentName) {
  if (!jsonString || !jsonString.trim()) return fallback;
  try {
    const parsed = JSON.parse(jsonString.replace(/,\s*([}\]])/g, "$1"));
    return typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
  } catch (error) {
    return fallback;
  }
}
const LISTING_REVEAL_CONTROLLER_SELECTOR = "slideshow-component, media-bg-component, [data-tab-item], custom-dialog, cart-drawer, quick-view-dialog, custom-div-popup, .megamenu-v2";
const LISTING_REVEAL_VIEWPORT_BUFFER = 64;
function getListingRevealController(host) {
  var _a;
  return ((_a = host == null ? void 0 : host.closest) == null ? void 0 : _a.call(host, LISTING_REVEAL_CONTROLLER_SELECTOR)) || null;
}
function ensureListingRevealReadyForPlay(host) {
  var _a;
  if (host == null ? void 0 : host._ready) return true;
  if (!getListingRevealController(host)) return false;
  return ((_a = host.setup) == null ? void 0 : _a.call(host)) === true;
}
function canSetupListingReveal(host, { allowController = true } = {}) {
  if (!(host == null ? void 0 : host.isConnected)) return false;
  if (allowController && getListingRevealController(host)) return true;
  const rect = host.getBoundingClientRect();
  const buffer = LISTING_REVEAL_VIEWPORT_BUFFER;
  return rect.bottom < -64 || rect.top > window.innerHeight + buffer || rect.right < -64 || rect.left > window.innerWidth + buffer;
}
function cacheListingEmblaNodes(host, {
  singleNavigation = false,
  scopeToEmbla = false,
  excludeNestedViewports = true
} = {}) {
  host.nodes.embla = host.querySelector(".embla");
  if (!host.nodes.embla) return;
  host.nodes.viewport = host.nodes.embla.querySelector(".embla__viewport");
  host.nodes.container = host.nodes.embla.querySelector(".embla__container");
  const scope = scopeToEmbla ? host.nodes.embla : host;
  const outsideNestedViewport = (element) => !excludeNestedViewports || !element.closest(".embla__viewport");
  const prevBtns = Array.from(
    scope.querySelectorAll(".embla__snip-button--prev button")
  ).filter(outsideNestedViewport);
  const nextBtns = Array.from(
    scope.querySelectorAll(".embla__snip-button--next button")
  ).filter(outsideNestedViewport);
  const dots = Array.from(scope.querySelectorAll(".embla__snip-dots")).find(
    outsideNestedViewport
  );
  if (singleNavigation) {
    host.nodes.prevBtn = prevBtns[0] || null;
    host.nodes.nextBtn = nextBtns[0] || null;
  } else {
    host.nodes.prevBtns = prevBtns;
    host.nodes.nextBtns = nextBtns;
  }
  host.nodes.dots = dots || null;
}
function cleanupListingFeatureHandlers(host) {
  var _a;
  (_a = host.featureCleanups) == null ? void 0 : _a.forEach((cleanup) => {
    try {
      cleanup();
    } catch {
    }
  });
  host.featureCleanups = [];
}
function eachControl(control, callback) {
  if (!control) return;
  if (Array.isArray(control) || control instanceof NodeList) {
    control.forEach((element) => eachControl(element, callback));
    return;
  }
  callback(control);
}
function toggleControl(control, show, toggleDisabled) {
  eachControl(control, (element) => {
    element.style.display = show ? "" : "none";
    if (!toggleDisabled) return;
    const buttons = element.tagName === "BUTTON" ? [element] : Array.from(element.querySelectorAll("button"));
    buttons.forEach((button) => {
      if (show) button.removeAttribute("disabled");
      else button.setAttribute("disabled", "");
    });
  });
}
function setupListingEmblaFeatures(host, {
  respectFeatureFlags = false,
  singleNavigation = false,
  deferControlWrites = false,
  toggleDisabled = false
} = {}) {
  cleanupListingFeatureHandlers(host);
  const isActive = host.emblaApi.internalEngine().options.active;
  const snapCount = host.emblaApi.scrollSnapList().length;
  const isVisible = isActive && snapCount > 1;
  const prev = singleNavigation ? host.nodes.prevBtn : host.nodes.prevBtns;
  const next = singleNavigation ? host.nodes.nextBtn : host.nodes.nextBtns;
  const apply = () => {
    toggleControl(host.nodes.dots, isVisible, toggleDisabled);
    toggleControl(prev, isVisible, toggleDisabled);
    toggleControl(next, isVisible, toggleDisabled);
    if (!isVisible) return;
    if (!respectFeatureFlags || host.config.showNavigation) {
      host.enableNavigation();
    }
    if (!respectFeatureFlags || host.config.showDots) host.enableDots();
  };
  if (deferControlWrites) requestAnimationFrame(apply);
  else apply();
}
function registerFeatureCleanup(host, cleanup, registerWithCleanup) {
  if (registerWithCleanup) host.registerCleanup(cleanup);
  else host.featureCleanups.push(cleanup);
}
function enableListingNavigation(host, { singleNavigation = false, registerWithCleanup = false } = {}) {
  if (!host.emblaApi) return;
  if (singleNavigation) {
    const { prevBtn, nextBtn } = host.nodes;
    if (!prevBtn || !nextBtn) return;
    registerFeatureCleanup(
      host,
      addPrevNextBtnsClickHandlersSSR(host.emblaApi, prevBtn, nextBtn),
      registerWithCleanup
    );
    return;
  }
  const { prevBtns, nextBtns } = host.nodes;
  if (!(prevBtns == null ? void 0 : prevBtns.length) || !(nextBtns == null ? void 0 : nextBtns.length)) return;
  prevBtns.forEach((prevBtn, index) => {
    const nextBtn = nextBtns[index];
    if (!nextBtn) return;
    registerFeatureCleanup(
      host,
      addPrevNextBtnsClickHandlersSSR(host.emblaApi, prevBtn, nextBtn),
      registerWithCleanup
    );
  });
}
function enableListingDots(host, { useOriginalSlideCount = false, registerWithCleanup = false } = {}) {
  const { dots } = host.nodes;
  if (!dots || !host.emblaApi) return;
  const dotsInner = dots.querySelector(".embla__dots-inner") || dots;
  const ssrDotCount = dotsInner.querySelectorAll(".embla__dot").length;
  const snapCount = host.emblaApi.scrollSnapList().length;
  const originalCount = useOriginalSlideCount && host.originalSlideCount > 0 ? host.originalSlideCount : null;
  const targetSnapCount = originalCount || snapCount;
  const cleanup = ssrDotCount >= targetSnapCount ? addDotsBtnsAndClickHandlersSSR(host.emblaApi, dots, originalCount) : addInstagramDotBtnsAndClickHandlers(
    host.emblaApi,
    dotsInner,
    originalCount
  );
  registerFeatureCleanup(host, cleanup, registerWithCleanup);
}
function flattenListingLayout(host) {
  const container = host.nodes.container;
  if (!container) return;
  const slides = host.originalItems.map((item) => {
    const slide = document.createElement("div");
    slide.className = "embla__slide";
    slide.appendChild(item);
    return slide;
  });
  container.replaceChildren(...slides);
}
function applyListingGridLayout(host) {
  var _a;
  const { rows, itemsPerRow } = host.getCurrentGridConfig();
  const itemsPerPage = rows * itemsPerRow;
  const items = host.originalItems;
  const slides = [];
  for (let pageStart = 0; pageStart < items.length; pageStart += itemsPerPage) {
    const page = items.slice(pageStart, pageStart + itemsPerPage);
    if (page.length < itemsPerPage) {
      for (let index = 0; index < page.length; index += rows) {
        const slide = document.createElement("div");
        slide.className = "embla__slide embla__slide-group";
        slide.style.setProperty("--slide-rows", rows);
        for (let row = 0; row < rows && index + row < page.length; row++) {
          slide.appendChild(page[index + row]);
        }
        slides.push(slide);
      }
      continue;
    }
    for (let column = 0; column < itemsPerRow; column++) {
      const slide = document.createElement("div");
      slide.className = "embla__slide embla__slide-group";
      slide.style.setProperty("--slide-rows", rows);
      for (let row = 0; row < rows; row++) {
        const item = page[row * itemsPerRow + column];
        if (item) slide.appendChild(item);
      }
      slides.push(slide);
    }
  }
  (_a = host.nodes.container) == null ? void 0 : _a.replaceChildren(...slides);
}
function destroyListingEmbla(host) {
  cancelDesignModeListingInit(host);
  cleanupListingFeatureHandlers(host);
  host.cleanupFunctions.forEach((cleanup) => {
    try {
      cleanup();
    } catch {
    }
  });
  host.cleanupFunctions = [];
  if (!host.emblaApi) return;
  try {
    host.emblaApi.destroy();
  } catch {
  }
  host.emblaApi = null;
}
function trimListingLoopClones(host) {
  if (host.originalSlideCount > 0 && host.nodes.container) {
    Array.from(host.nodes.container.children).slice(host.originalSlideCount).forEach((slide) => slide.remove());
  }
  host.originalSlideCount = 0;
}
export {
  applyListingGridLayout,
  cacheListingEmblaNodes,
  canSetupListingReveal,
  cancelDesignModeListingInit,
  cleanupListingFeatureHandlers,
  destroyListingEmbla,
  enableListingDots,
  enableListingNavigation,
  ensureListingRevealReadyForPlay,
  flattenListingLayout,
  getListingRevealController,
  parseLiquidJSON,
  scheduleDesignModeListingInit,
  setupListingEmblaFeatures,
  trimListingLoopClones
};
